contently.ui.collapseContainer = (e) ->
  el = if !!$(e.target).length then $(e.target) else $(e)
  unless el.is(".js-prevent-toggle, .dropdown-container *")
    clickedContainer = el.closest(".collapsible-container")

    $.when(
      clickedContainer.toggleClass "active"
    ).done(() =>
      $(e.currentTarget).trigger("collapsible:toggled", [{activated: clickedContainer.hasClass("active")}])
    )

$(document).on "click", ".js-toggle-collapsible", (e) ->
  contently.ui.collapseContainer(e)

$(document).on "change", ".js-checkbox-toggle-collapsible input", (e) ->
  contently.ui.collapseContainer($(e.target))

collapseMultiCollapsible = (e) ->
  $(e.currentTarget)
    .closest(".multi-collapsible-wrapper")
    .find(".collapsible-container")
    .removeClass("active")

$(document).on "click", ".js-multi-collapsible-collapse", collapseMultiCollapsible

expandMultiCollapsible = (e) ->
  $(e.currentTarget)
    .closest(".multi-collapsible-wrapper")
    .find(".collapsible-container")
    .addClass("active")

$(document).on "click", ".js-multi-collapsible-expand", expandMultiCollapsible



// WEBPACK FOOTER //
// ./app/javascript/lib/toolkit/behaviors/collapsible.js.coffee